import { listenerMiddleware } from '../listener.middleware';
import { SourceType, surgeryInfoApi } from '@/modules/surgicalEvent';
import { type RootState } from '@/store';
import { enqueueSnackbar } from 'notistack';

listenerMiddleware.startListening({
  matcher: surgeryInfoApi.endpoints.surgeryInfo.matchFulfilled,
  effect: (action, api) => {
    const selectData = surgeryInfoApi.endpoints.surgeryInfo.select(
      action.meta.arg.originalArgs
    );

    const oldData = selectData(api.getOriginalState() as RootState).data;
    if (oldData) {
      const newData = selectData(api.getState() as RootState).data;
      const newSourceType = newData?.asaScoreSourceType;
      const oldAsa = oldData.asaScore;
      const newAsa = newData?.asaScore;
      if (newSourceType === SourceType.AI_SUGGESTION && oldAsa !== newAsa) {
        enqueueSnackbar('', {
          variant: 'asa',
          asa: newAsa
        });
      }
    }
  }
});
